import { useContext } from 'react';
import { VirtualSlotsPlaceholderHostId } from '../slotsPlaceholderContext';
export const useSlotUniqueId = (slotId) => {
    const hostCompId = useContext(VirtualSlotsPlaceholderHostId);
    return `${hostCompId}.${slotId}`;
};
//# sourceMappingURL=useSlotUniqueId.js.map